import React from 'react'

const Overview = () => {
  return (
    <div className="overview-container">
        <div className="first">
            <div className="task-conatiner">

            </div>
            <div className="track">
                <h1>Manage and Track Your Projects</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, perspiciatis?</p>
                <div className="checkpoints">
                    
                </div>
            </div>
        </div>
    </div>
  )
}

export default Overview